import { Box, TextField, Typography } from '@mui/material';
import { inRange } from 'lodash';
import React from 'react';

type Props = {
	setWidth: (width: number) => void;
	setHeight: (height: number) => void;
	width: number;
	height: number;
};

export default ({ setHeight, setWidth, width, height }: Props) => (
	<Box display="flex" gap={1} alignItems="center">
		<Typography variant="body1" color="text.primary">
			{intl.tr('screenEditor.actionBar.previewSize.title')}:
		</Typography>
		<TextField
			sx={{ width: 75 }}
			data-testid="change-canvas-width"
			size="small"
			value={width || ''}
			onChange={(e) => {
				if (!e.target.value) setWidth(0);
				const num = Number.parseInt(e.target.value, 10);
				if (inRange(num, 1, 10000)) setWidth(num);
			}}
			placeholder={intl.tr(
				'screenEditor.actionBar.previewSize.inputPlaceholder'
			)}
		/>
		<Typography variant="body1" color="text.primary">
			X
		</Typography>
		<TextField
			sx={{ width: 73 }}
			data-testid="change-canvas-height"
			size="small"
			value={height || ''}
			onChange={(e) => {
				if (!e.target.value) setHeight(0);
				const num = Number.parseInt(e.target.value, 10);
				if (inRange(num, 1, 10000)) setHeight(num);
			}}
			placeholder={intl.tr(
				'screenEditor.actionBar.previewSize.inputPlaceholder'
			)}
		/>
	</Box>
);
